import { CSSProperties, FC, ReactNode } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
interface PageContainerProps {
  title?: ReactNode;
  children?: ReactNode;
  id?: string;
  nowrap?: boolean;
  noBodyWrap?: boolean;
  wrapStyle?: CSSProperties;
  className?: string;
  noMargin?: boolean;
  noPadding?: boolean;
}
const PageContainer: FC<PageContainerProps> = ({ title, children, id, nowrap = false, noBodyWrap = false, wrapStyle, className, noMargin, noPadding }) => {
  return (
    <div
      className={cs(styles[`page-container-wrapper`],
        { [styles['no-padding-margin']]: nowrap, [styles['no-margin']]: noMargin, [styles['no-padding']]: noPadding, }, className)}
      style={wrapStyle}>
      <div className={styles['page-container']}>
        {title && (
          <div className={styles[`page-container-header-wrapper`]} id={id}>
            <div className={styles[`page-container-header`]}>
              <div className={cs({ [styles[`page-container-title`]]: title })}>{title}</div>
            </div>
          </div>
        )}
        <div>
          <div className={cs(styles[`page-container-body`], { [styles['no-padding-margin']]: noBodyWrap })}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PageContainer;
